import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthenticationService } from '@shared/services/authentication.service';

@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.css']
})
export class LinkComponent implements OnInit {

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthenticationService
  ) {}

  ngOnInit() {
    const queryParams = this.activatedRoute.snapshot.queryParams;
    this.switchRoutes(queryParams.type, queryParams.id);
  }

  switchRoutes(type: string, id: string) {
    let route: string;
    const roleType = this.authService.getRole();
    switch (type) {
      case 'research':
        if (roleType === 'tech_vendor') {
          route = 'market-data';
        } else {
          route = 'research-snapshot';
        }
      break;
      case 'report':
        if (roleType === 'tech_analyst') {
          route = 'reports/report-details';
        } else {
          route = '/report-details';
        }
      break;
      case 'analyst':
      route = '/analyst-profile';
      break;
      case 'social_feed':
      route = '/social-feeds';
      break;
      case 'profile':
        route = '/my-profile';
      break;
    }
    this.navigate(route, id);
  }

  navigate(route: string, id: string) {
    const roleType = this.authService.getRole();
    let role: string;
    if (roleType === "tech_buyer") {
      role = 'tech-buyer';
    } else if (roleType === "tech_vendor") {
      role = 'tech-vendor';
    } else if (roleType === "tech_analyst") {
      role = 'tech-analyst';
    } else if (roleType === "ecosystm_staff") {
      role = 'ecosystm-staff';
    }
    if (role && route) {
      if (id && route === '/analyst-profile') {
        this.router.navigate([`${route}`], { queryParams: { analystId: id } });
      } else if (id && route !== '/analyst-profile') {
        this.router.navigate([`${role}/${route}/${id}`]);
      } else {
        this.router.navigate([`${role}/${route}`]);
      }
    } else {
      localStorage.setItem('REDIRECT_URL', document.location.hash.replace('#', ''));
      this.router.navigate(['/signin']);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/feature/external/link/link.component.ts